import http from '../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/guoke',
    GKListPage(query) {
        return http({
            url: this.baseurl + '/guokeOrder/selectPage',
            method: 'get',
            params: query
        });
    },
    ExportGKList(query) {
        return http({
            url: this.baseurl + '/guokeOrder/downloadExcel',
            method: 'get',
            params: query,
            responseType: 'blob'
        });
    },
    InventoryListPage(query){
        return http({
            url: this.baseurl + '/nationalScience/selectListPage',
            method: 'post',
            params: query
        });
    },
    ExportInventoryList(query) {
        return http({
            url: this.baseurl + '/nationalScience/downloadExcel',
            method: 'post',
            params: query,
            responseType: 'blob'
        });
    },

    getInvoice(query) {
        return http({
            url: this.baseurl + '/guokeOrder/getInvoiceFileByNo',
            method: 'get',
            params: query
        });
    },

    updateSalesRegion(query) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeOrderSalesRegion/updateSalesRegion',
            method: 'post',
            params: query
        });
    },

    gkOrderList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeOrderSalesRegion/gkOrderList',
            method: 'post',
            params: query
        });
    },
    gkOrderPass(query) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeOrderSalesRegion/gkOrderPass',
            method: 'post',
            data: query
        });
    },

}
